"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _image = require("@site/pattern-library-core/image");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _index2 = _interopRequireDefault(require("../../../elements/other/lazy-video/index.js"));
var _playButton = _interopRequireDefault(require("../../media-components/video-lightbox/play-button.js"));
var _index3 = _interopRequireDefault(require("../../../elements/buttons/play-button/index.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-chz7pee",
  vars: {
    "chz7pee-6": [({
      active
    }) => active ? `${_intents.default.ux.controlFocused.backgroundColor}` : 'transparent'],
    "chz7pee-8": [({
      active
    }) => active ? `${_intents.default.ux.controlFocused.foregroundColor}` : `${_intents.default.ux.control.foregroundColor}`]
  }
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyPicture)({
  name: "ImageContainer",
  class: "pl-i18fuk58"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-v1fhgiay"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_index2.default)({
  name: "Video",
  class: "pl-v5les5q"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c1drraik"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hj2p61o"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-b1o1trt0"
});
const Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-ckinrh"
});

/**
 * ImageCard Component.
 *
 * @param {Object} props React props
 * @param {Boolean} props.isMobileImage Is Mobile Image
 * @param {Object} props.portrait Mobile Portrait Image
 * @param {Function} props.setIsMobileImage Mobile Image setter
 * @param {String} props.lightboxUrl Lightbox Url
 * @param {String} props.youTubeId YouTube Video Id
 * @param {Function} props.lightboxHandlePlay Lightbox Play Handler
 * @returns {React.ReactElement} ImageCard Component
 * @public
 */
function ImageCard({
  isMobileImage,
  portrait,
  setIsMobileImage,
  lightboxUrl,
  youTubeId,
  lightboxHandlePlay
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    dataCy: "mobile-image-container",
    className: isMobileImage && 'active',
    defaultAltText: portrait?.altText,
    onLoad: setIsMobileImage
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: portrait?.url,
    media: `${_patternLibraryUtils.deviceMax.tabletLg}`
  })), (lightboxUrl || youTubeId) && /*#__PURE__*/_react.default.createElement(Controls, {
    className: "lightbox-control"
  }, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "lightbox-video-play-button",
    handlePlay: lightboxHandlePlay,
    size: "medium"
  })));
}
ImageCard.propTypes = {
  isMobileImage: _propTypes.default.bool,
  portrait: _propTypes.default.object,
  setIsMobileImage: _propTypes.default.func,
  lightboxUrl: _propTypes.default.string,
  youTubeId: _propTypes.default.string,
  lightboxHandlePlay: _propTypes.default.func
};

/**
 * VideoCard Component.
 *
 * @param {Object} props React props
 * @param {Object} props.videoSource Video Source object
 * @param {Boolean} props.play Play Video
 * @param {Function} props.handleChange Handle Play
 * @param {String} props.preload Preload Video setting
 * @returns {React.ReactElement} VideoCard Component
 * @public
 */

function VideoCard({
  videoSource,
  play,
  handleChange,
  preload
}) {
  return /*#__PURE__*/_react.default.createElement(VideoContainer, {
    "data-cy": "inline-mobile-video-container"
  }, /*#__PURE__*/_react.default.createElement(Video, {
    videoSource: videoSource,
    preload: preload,
    loop: true,
    autoPlay: true,
    pause: play
  }), /*#__PURE__*/_react.default.createElement(Controls, null, /*#__PURE__*/_react.default.createElement(_index3.default, {
    dataCy: "inline-video-play-button",
    handlePlay: () => handleChange(),
    pause: !play,
    size: "small"
  })));
}
VideoCard.propTypes = {
  videoSource: _propTypes.default.object,
  play: _propTypes.default.bool,
  handleChange: _propTypes.default.func,
  preload: _propTypes.default.oneOf(['auto', 'metadata', 'none'])
};

/**
 * CardItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.heading Card Heading
 * @param {String} props.headlineTag Card Heading Tag
 * @param {String} props.headlineSize Card Heading Size
 * @param {Number} props.headlineLineLength Card Heading Line Length
 * @param {String} props.description Card Description
 * @param {Array} props.ctas Card Button
 * @param {Function} props.handleAction Hover Active Function
 * @param {Object} props.portrait Mobile Image Portrait
 * @param {Boolean} props.active Active card check
 * @param {String} props.lightboxUrl Lightbox Url
 * @param {String} props.youTubeId youTubeId
 * @param {Function} props.lightboxHandlePlay Lightbox trigger function
 * @returns {React.ReactElement} CardItem Component
 * @public
 */

function CardItem({
  eyebrow,
  heading,
  description,
  ctas,
  handleAction,
  portrait,
  active,
  videoSource,
  preload,
  lightboxUrl,
  youTubeId,
  lightboxHandlePlay,
  headlineTag = 'h3',
  headlineSize = 'h6',
  headlineLineLength = 2,
  priceLockup,
  partial
}) {
  const [isMobileImage, setIsMobileImage] = (0, _react.useState)(false);
  const [userToggledPlay, setUserToggledPlay] = (0, _react.useState)(false);
  const handleChange = () => setUserToggledPlay(prevCheck => !prevCheck);
  const shouldPlay = !active || userToggledPlay;
  return /*#__PURE__*/_react.default.createElement(CardContainer, {
    tabIndex: 0,
    onMouseOver: handleAction,
    onFocus: handleAction,
    active: active,
    partial: partial
  }, /*#__PURE__*/_react.default.createElement(Content, {
    "data-cy": "product-card"
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    className: ctas && 'has-cta'
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    eyebrow: eyebrow,
    heading: heading,
    description: description,
    headlineTag: headlineTag,
    headlineSize: headlineSize,
    textAlign: "start",
    actionsLayout: "button-set",
    headlineLineLength: headlineLineLength,
    priceLockup: priceLockup
  })), ctas && /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    "data-cy": "button-wrapper",
    "data-partial": partial === 'dark1' && active ? 'light1' : partial
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: ctas
  }))), portrait?.url && /*#__PURE__*/_react.default.createElement(ImageCard, {
    isMobileImage,
    portrait,
    setIsMobileImage: () => setIsMobileImage(true),
    lightboxUrl,
    youTubeId,
    lightboxHandlePlay
  }), !portrait?.url && /*#__PURE__*/_react.default.createElement(VideoCard, {
    videoSource,
    preload,
    play: shouldPlay,
    handleChange: () => handleChange(false)
  }));
}
var _default = exports.default = CardItem;
CardItem.propTypes = {
  eyebrow: _propTypes.default.string,
  heading: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  headlineSize: _propTypes.default.string,
  headlineLineLength: _propTypes.default.number,
  description: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes)),
  handleAction: _propTypes.default.func,
  portrait: _propTypes.default.object,
  active: _propTypes.default.bool,
  videoSource: _propTypes.default.object,
  preload: _propTypes.default.oneOf(['auto', 'metadata', 'none']),
  lightboxUrl: _propTypes.default.string,
  youTubeId: _propTypes.default.string,
  lightboxHandlePlay: _propTypes.default.func,
  priceLockup: _propTypes.default.object,
  partial: _propTypes.default.string
};